import { API, graphqlOperation } from "aws-amplify";
import {
  parseToFloat,
  CURRENCY_FORMATER,
  dateToAWSDate
} from "@/services/Formatting.js";
import {
  TRANSACTION_STATUSES,
  GET_TRANSACTION_STATUS_ARRAY
} from "@/components/transaction/TransactionStatusList.js";
import AppSettings from "@/appsettings/appsettings.js";

const SEARCH_CATEGORY = {
  ByTransactionDate: "byTransactionDate",
  ByOrderNumber: "byOrderNumber",
  ByTransactionStatusAndDate: "byTransactionStatusAndDate",
  ByCustomerId: "byCustomerId"
};

const DEFAULT_DAYS_IN_THE_PAST =
  AppSettings.transactionTableDefaultDate.daysInThePast;
const DEFAULT_DAYS_IN_THE_FUTURE =
  AppSettings.transactionTableDefaultDate.daysInTheFuture;

const DEFAULT_DATE_RANGE = () => {
  const from = new Date();
  from.setDate(from.getDate() - DEFAULT_DAYS_IN_THE_PAST);
  const to = new Date();
  to.setDate(to.getDate() + DEFAULT_DAYS_IN_THE_FUTURE);
  return {
    from,
    to
  };
};

const DEFAULT_SEARCH_MODEL = {
  customerId: "",
  orderNumber: "",
  transactionStatus: ["any"],
  dateRange: DEFAULT_DATE_RANGE
};

const SHOW_DECLINED_TRANSACTIONS_BY_DEFAULT = false;

const DEFAULT_AMOUNT_OF_RECORDS_TO_RETRIEVE_FROM_BACKEND = 20;

export default {
  parseToFloat,
  data() {
    return {
      transactions: [],
      transactionStatuses: TRANSACTION_STATUSES,
      quickSearch: "",
      loading: false,
      nextToken: null,
      searchModel: {
        customerId: DEFAULT_SEARCH_MODEL.customerId,
        orderNumber: DEFAULT_SEARCH_MODEL.orderNumber,
        transactionStatus: DEFAULT_SEARCH_MODEL.transactionStatus,
        dateRange: DEFAULT_SEARCH_MODEL.dateRange()
      },
      transactionStatusArray: GET_TRANSACTION_STATUS_ARRAY(),
      refreshTableHeaders: null,
      displayDeclinedTransactions: SHOW_DECLINED_TRANSACTIONS_BY_DEFAULT
    };
  },
  computed: {
    tenantAlias() {
      return this.$store.getters.merchantId;
    },
    searchCategory() {
      if (this.isCustomerIdSet) return SEARCH_CATEGORY.ByCustomerId;

      if (this.isOrderNumberSet) return SEARCH_CATEGORY.ByOrderNumber;

      if (this.isStatusSearchSet)
        return SEARCH_CATEGORY.ByTransactionStatusAndDate;

      return SEARCH_CATEGORY.ByTransactionDate;
    },
    isCustomerIdSet() {
      return !!this.searchModel.customerId && this.searchModel.customerId != "";
    },
    isOrderNumberSet() {
      return (
        !!this.searchModel.orderNumber && this.searchModel.orderNumber != ""
      );
    },
    isStatusSearchSet() {
      const statusSearch = this.searchModel.transactionStatus;
      return (
        !!statusSearch && !!statusSearch.length && !statusSearch.includes("any")
      );
    },
    formatedDateRangeFrom() {
      return this.formatDateForBackEnd(this.searchModel.dateRange.from);
    },
    formatedDateRangeTo() {
      return this.formatDateForBackEnd(this.searchModel.dateRange.to);
    }
  },
  methods: {
    async getTransactions(nextToken) {
      const searchTransaction = `
          query SearchTransaction(
            $body: QuerySearchTransactionBodyInput
          ) {
            searchTransaction(body: $body) {
              nextToken
              data{
                intentId
                isRecurring
                transactionId
                orderNumber
                transactionDate
                amount
                currencyText
                firstName
                lastName
                email
                customFields
                transactionStatus
                cardType
                hasPromotionalCode
                promotionalCodeId
                customerId
              }
            }
          }
        `;

      const searchCategory = this.searchCategory;
      const tenantAlias = this.tenantAlias;
      let dateRange = {
        startDate: this.formatedDateRangeFrom,
        endDate: this.formatedDateRangeTo
      };
      let orderNumber = null;
      let customerId = null;
      let transactionStatus = null;

      if (this.isOrderNumberSet) {
        orderNumber = this.searchModel.orderNumber;
      }
      if (this.isStatusSearchSet) {
        transactionStatus = this.searchModel.transactionStatus[0];
      }
      if (this.isCustomerIdSet) {
        customerId = this.searchModel.customerId;
      }

      let filter = {
        limit: DEFAULT_AMOUNT_OF_RECORDS_TO_RETRIEVE_FROM_BACKEND,
        nextToken
      };
      const searchTransactionQuery = {
        searchCategory,
        tenantAlias,
        filter,
        orderNumber,
        dateRange,
        transactionStatus,
        customerId
      };

      const searchResponse = await API.graphql(
        graphqlOperation(searchTransaction, {
          body: searchTransactionQuery
        })
      );

      this.nextToken = searchResponse.data.searchTransaction.nextToken;

      return searchResponse.data.searchTransaction.data;
    },
    async getFormatedTransactions(nextToken) {
      const transactions = await this.getTransactions(nextToken);
      return transactions.map(this.formatTransactions);
    },
    refreshHeaders() {
      if (this.refreshTableHeaders && this.transactions.length)
        this.refreshTableHeaders(this.transactions[0]);
    },
    async searchEvent() {
      this.loading = true;
      try {
        this.transactions = await this.getFormatedTransactions();
        this.refreshHeaders();
      } catch (err) {
        this.loading = false;
        throw err;
      }
      this.loading = false;
    },
    async loadMoreTransactions() {
      if (!this.nextToken) return;
      this.loading = true;
      try {
        const newTransactions = await this.getFormatedTransactions(
          this.nextToken
        );
        this.transactions = this.transactions.concat(newTransactions);
      } catch (err) {
        this.loading = false;
        throw err;
      }
      this.loading = false;
    },
    resetSearch() {
      this.searchModel.orderNumber = DEFAULT_SEARCH_MODEL.orderNumber;
      this.searchModel.customerId = DEFAULT_SEARCH_MODEL.customerId;
      this.searchModel.transactionStatus =
        DEFAULT_SEARCH_MODEL.transactionStatus;
      this.searchModel.dateRange = DEFAULT_SEARCH_MODEL.dateRange();

      this.displayDeclinedTransactions = SHOW_DECLINED_TRANSACTIONS_BY_DEFAULT;
    },
    extractCustomFields(fields) {
      if (!fields) return {};
      const fieldsObject = JSON.parse(fields);
      return fieldsObject;
    },
    extractDateFromTime(dateTime) {
      const date = new Date(dateTime);
      let dateString = date.toDateString();
      dateString = dateString.substr(dateString.indexOf(" ") + 1);
      const timeString = date.toLocaleTimeString();
      return { date: `${dateString}\n${timeString}` };
    },
    formatAmount(amount) {
      amount = parseToFloat(amount).toFixed(2);
      return CURRENCY_FORMATER.format(amount);
    },
    formatTransactions(transaction) {
      const dateTime = this.extractDateFromTime(transaction.transactionDate);
      transaction.amount = this.formatAmount(transaction.amount);
      const customFields = this.extractCustomFields(transaction.customFields);

      return { ...transaction, ...dateTime, ...customFields };
    },
    formatDateForBackEnd(date) {
      return dateToAWSDate(date);
    },
    async resetAndSearch() {
      this.resetSearch();
      await this.searchEvent();
    },
    async customerIdSearch(cid) {
      this.searchModel.customerId = cid;
      await this.searchEvent();
    }
  }
};
